'use client'

import * as React from 'react'

type FieldProps = {
  path: string
}

type FieldContextValue = {
  path: string
  id: string
}

const FieldContext = React.createContext<FieldContextValue>({} as FieldContextValue)

export const useFormField = () => {
  return React.useContext(FieldContext)
}

export const Field = ({ path, ...props }: FieldProps & React.HTMLAttributes<HTMLDivElement>) => {
  const id = React.useId()

  return (
    <FieldContext.Provider value={{ id, path }}>
      <div {...props} />
    </FieldContext.Provider>
  )
}
